import model from '../../models-v2/crm/crm-mails';
import routeName from '../route-name';

export default [
  {
    path: '/mailing/inbox',
    name: routeName.crmMails.index,
    components: {
      default: () => import('../../views/pages/mailing/components/MailingInboxList.vue'),
      topRightSection: () => import('../../views/pages/mailing/components/MailingInboxTopRightSection.vue'),
      popup: () => import('../../views/pages/mailing/components/EnhancedEmailPreview.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Mailing', url: '/mailing' },
        { title: 'Odebrane', url: '/mailing/inbox' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
